<template>
  <list-table
    :url="url"
    title="تراکنش های ریفاند"
    :fields="fields"
    :params="params"
    :isForExcel="true"
  ></list-table>
</template>
<script>
import TableShowData from "../../components/table";
import { GET_USER_LIST } from "@/core/services/store/getUserList.module";
import persianDate from '../../helpers/persianDate';
export default {
  name: "RefundTransactionList",
  data() {
    return {
      url: "refund/transactions",
      fields: [
        {
          key: "id",
          label: "کد درخواست",
        },
        {
          key: "transaction_id",
          label: "کد تراکنش برگشت شده",
        },
        {
          key: "created_at",
          label: "تاریخ و ساعت", formatter: (value, key, item) => {
            return persianDate.getDate(item.created_at);
          },
        },
        {
          key: "website",
          label: "وب سایت",
         
        },
        {
          key: "card_holder_pan",
          label: "شماره کارت مقصد",
          tdClass:'ltr'
        },
        {
          key: "sale_reference_id",
          label: "کد رهگیری تراکنش اصلی",
         
        },
        {
          key: "refund_tracknumber",
          label: "کد رهگیری تراکنش برگشت",
         
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          tdClass:'ltr',
          formatter(value, key, item) {
            return item.bes-item.bed<0 ? ((item.bes-item.bed)*(-1)).toLocaleString() : (item.bes-item.bed).toLocaleString();
          },
        },
        {
          key: "karmozd",
          label: "کارمزد (ریال)",
          tdClass:'ltr',
          formatter(value, key, item) {
           
            return item.karmozd ? value.toLocaleString() : 0;
          },
        },
      ],
      params: [
        {
          label: "از تاریخ :",
          field: "dateFrom",
          type: "date-picker"
        },
        {
          label: "تا تاریخ:",
          field: "dateTo",
          type: "date-picker"
        },
        {
          label: "سایت:",
          field: "website",
           type: "text"
         
        },
        {
          label: "شماره پیگیری:",
          field: "refundTrackNumber",
          type: "text"
        },
        {
          label: "شماره کارت:",
          field: "cardNumber",
          type: "text"
        },
        {
          label: "مبلغ (ریال) :",
          field: "amount",
          type: "number"
        },
        {
          label: "پذیرنده",
          field: "user_id",
          type: "select",
          value: null,
          options: [],
        },
      ],
     
    };
  },
  components: {
    "list-table": TableShowData,
  },
 computed: {
    loadedUserList() {
      return this.$store.getters.loadedUserList;
    },
  },

  mounted() {
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$store.dispatch(GET_USER_LIST,'users-with-refund').then((data) => {
        let option = [{ text: "انتخاب نشده", value: null }];
        data.forEach((element) => {
          option.push({ text: element.name, value: element.id });
        });

        this.params[6].options = option;
      });
    },
  },
};
</script>
<style>
.ltr{
  direction: ltr;
}
</style>